/**
 * Each deploy replaces the hashed page files (assets/CommissionsPage-<hash>.js…); a tab opened before the
 * deploy still asks for the old names, Cloudflare answers with index.html, and the lazy page fails into
 * « Un problème est survenu ». The cure is a reload. The old guard allowed one reload per tab for its whole
 * life, so the second deploy a tab lived through showed the error page (bug 2026-10-26). Now: one reload,
 * then again only once the last one is a minute old — a page still broken right after reloading never loops.
 */
const KEY = "chunk-reload";
const MIN_GAP_MS = 60_000;

type Store = Pick<Storage, "getItem" | "setItem">;

export function shouldReloadForStaleChunk(
  storage: Store,
  now: number,
): boolean {
  const last = Number(storage.getItem(KEY));
  // The old one-shot flag "1" reads as a reload at epoch 1 — long ago.
  if (Number.isFinite(last) && last > 0 && now - last < MIN_GAP_MS)
    return false;
  storage.setItem(KEY, String(now));
  return true;
}
